export default "__VITE_ASSET__BIH7iDEg__"